import './Essay.css';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from './config';
import RichText from './RichText';
import Replies from './Replies';
import Notes from './Notes';

export default function Essay() {
  const { id } = useParams();
  const [essay, setEssay] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    setStatus('loading');
    fetch(api(`retrieve_messages.php?id=${encodeURIComponent(id)}`))
      .then(res => res.json())
      .then(data => {
        const post = (data.messages || [])[0];
        if (post) {
          setEssay(post);
          setStatus('ready');
        } else {
          setStatus('missing');
        }
      })
      .catch(() => setStatus('error'));
  }, [id]);

  if (status === 'loading') {
    return <div className='Essay_Container'><p className='Essay_Status'>Loading…</p></div>;
  }
  if (status !== 'ready') {
    return (
      <div className='Essay_Container'>
        <p className='Essay_Status'>
          {status === 'missing' ? "That essay doesn't exist." : "Couldn't load this essay. Try refreshing."}
        </p>
        <Link className='Essay_Back' to='/'>← BACK TO POSTS</Link>
      </div>
    );
  }

  return (
    <article className='Essay_Container'>
      <Link className='Essay_Back' to='/'>← BACK TO POSTS</Link>
      <h1 className='Essay_Title'>{essay.title || 'Untitled'}</h1>
      <span className='Essay_Date'>
        {new Date(essay.received_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
      </span>
      <Notes notes={essay.notes} />
      <div className={essay.notes && essay.notes.length > 0 ? 'Essay_Body Post_Original' : 'Essay_Body'}>
        <RichText text={essay.message} />
      </div>
      {essay.image_url && <img className='Essay_Image' src={essay.image_url} alt='' />}
      {essay.replies && essay.replies.length > 0 && (
        <section className='Essay_Replies'>
          <h2 className='Essay_Replies_Heading'>
            {essay.replies.length} {essay.replies.length === 1 ? 'REPLY' : 'REPLIES'}
          </h2>
          <Replies replies={essay.replies} />
        </section>
      )}
    </article>
  );
}
